import { useEffect, useState } from "react";
import useService from "./useService";

// O prestador tem contrato CLT ativo? Decide o "Ponto" do menu e o bloco do ponto no
// Dashboard dele. O resultado fica no sessionStorage para não consultar a cada
// navegação, e quem pede junto espera a mesma consulta.
const STORAGE_KEY = "has_clt_ow";
let pending = null;

/** A consulta só roda com `enabled` (no menu, quando ele é o que aparece). */
export default function useHasCltContract(enabled = true) {
  const contractService = useService("contracts");
  const [hasCltContract, setHasCltContract] = useState(sessionStorage.getItem(STORAGE_KEY) === "true");

  useEffect(() => {
    if (!enabled || sessionStorage.getItem(STORAGE_KEY) !== null) {
      return undefined;
    }
    let active = true;
    if (!pending) {
      pending = contractService
        .list("status=ACTIVE&limit=100")
        .then((result) => {
          const list = result?.data?.list || result?.data || [];
          const hasClt = Array.isArray(list) && list.some((c) => c.remuneration_type === "CLT");
          sessionStorage.setItem(STORAGE_KEY, String(hasClt));
          return hasClt;
        })
        .finally(() => {
          pending = null;
        });
    }
    pending
      .then((hasClt) => {
        if (active) setHasCltContract(hasClt);
      })
      .catch((err) => console.log(err));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return hasCltContract;
}
